import React from 'react';
import { AdminInviteUsers } from 'src/features/AdminInviteUsers/components/templates/AdminInviteUsers';
import { AdminInviteUsersContextProvider } from 'src/features/AdminInviteUsers/contexts/AdminInviteUsersContextProvider';

export const AdminInviteUsersDashboard: React.FC = () => {
  return (
    <AdminInviteUsersContextProvider>
      <AdminInviteUsers />
    </AdminInviteUsersContextProvider>
  );
};
